import React from 'react';
import Modal from '../../../components/Modal';
import AddSupplierModal from '../components/addSupplierModal';

const CreateBrandForm = ({ brandName, setBrandName, isSubmitting }) => {
  // Handle input change locally to prevent focus loss
  const handleInputChange = (e) => {
    const value = e.target.value;
    setBrandName(value);
  };

  // Prevent form submission on Enter key
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  return (
    <form id="createBrandForm" onSubmit={(e) => e.preventDefault()}>
      <div className="space-y-4">
        <div>
          <label htmlFor="brandName" className="block text-sm font-medium text-gray-700">
            Nom de la marque
          </label>
          <input
            type="text"
            name="brandName"
            id="brandName"
            value={brandName}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            disabled={isSubmitting}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#174540] focus:border-[#174540] sm:text-sm"
            placeholder="Entrez le nom de la marque"
            autoFocus
            required
          />
        </div>
      </div>
    </form>
  );
};

const CreationModals = ({
  isCreateSupplierModalOpen,
  setIsCreateSupplierModalOpen,
  handleSubmitNewSupplier,
  newSupplierName,
  setNewSupplierName,
  newSupplierEmail,
  setNewSupplierEmail,
  newSupplierTel,
  setNewSupplierTel,
  newSupplierAddress,
  setNewSupplierAddress,
  newSupplierFiscal,
  setNewSupplierFiscal,
  isSubmittingSupplier,
  isCreateBrandModalOpen,
  setIsCreateBrandModalOpen,
  handleSubmitNewBrand,
  newBrandName,
  setNewBrandName,
  isSubmittingBrand
}) => {
  return (
    <>
      {/* Supplier Creation Modal */}
      <AddSupplierModal
        isOpen={isCreateSupplierModalOpen}
        onClose={() => setIsCreateSupplierModalOpen(false)}
        onSubmit={handleSubmitNewSupplier}
        supplierName={newSupplierName}
        setSupplierName={setNewSupplierName}
        supplierEmail={newSupplierEmail}
        setSupplierEmail={setNewSupplierEmail}
        supplierTel={newSupplierTel}
        setSupplierTel={setNewSupplierTel}
        supplierAddress={newSupplierAddress}
        setSupplierAddress={setNewSupplierAddress}
        supplierFiscal={newSupplierFiscal}
        setSupplierFiscal={setNewSupplierFiscal}
        isSubmitting={isSubmittingSupplier}
      />

      {/* Brand Creation Modal */}
      <Modal
        isOpen={isCreateBrandModalOpen}
        onClose={() => setIsCreateBrandModalOpen(false)}
        title="Créer une nouvelle marque"
        onSubmit={handleSubmitNewBrand}
        size="md"
        isSubmitting={isSubmittingBrand}
        submitLabel="Créer"
      >
        <CreateBrandForm
          brandName={newBrandName}
          setBrandName={setNewBrandName}
          isSubmitting={isSubmittingBrand}
        />
      </Modal>
    </>
  );
};

export default CreationModals;